import {makeReactContext} from 'lib/makeReactContext';

import {INITIAL_STEP, MigrationStep} from '../types/MigrationStep';

export interface ConfigMigrationImportTabContextPayload {
  activeStep: MigrationStep;
  sourceOrganizationId?: string;
  destinationOrganizationId?: string;
}

const getDefaultContext = (): ConfigMigrationImportTabContextPayload => ({
  activeStep: INITIAL_STEP,
});

export const ConfigMigrationImportTabContext = makeReactContext<ConfigMigrationImportTabContextPayload>(
  getDefaultContext,
  'ConfigMigrationPageContext'
);

/**
 * A context for sharing information from the current ConfigMigration Import tab (ImportWizard).
 */
export function useConfigMigrationImportTabContext(): ConfigMigrationImportTabContextPayload {
  return ConfigMigrationImportTabContext.useContext();
}
